var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C24 17 24 13.25 24 13.25C24 12.6533 23.763 12.081 23.341 11.659C22.9191 11.2371 22.3468 11 21.75 11H14.244C13.6473 11 13.075 11.2371 12.653 11.659C12.2311 12.081 11.994 12.6533 11.994 13.25C11.994 13.25 11.994 17 17.994 17H18Z",
    fill: "url(#paint0_linear_2862_471)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C24 17 24 13.25 24 13.25C24 12.6533 23.763 12.081 23.341 11.659C22.9191 11.2371 22.3468 11 21.75 11H14.244C13.6473 11 13.075 11.2371 12.653 11.659C12.2311 12.081 11.994 12.6533 11.994 13.25C11.994 13.25 11.994 17 17.994 17H18Z",
    fill: "url(#paint1_radial_2862_471)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.25C0 12.6533 0.237053 12.081 0.65901 11.659C1.08097 11.2371 1.65326 11 2.25 11H12.75C13.3467 11 13.919 11.2371 14.341 11.659C14.7629 12.081 15 12.6533 15 13.25V13.75C15 13.75 15 19 7.5 19C0 19 0 13.75 0 13.75V13.25Z",
    fill: "url(#paint2_linear_2862_471)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.25C0 12.6533 0.237053 12.081 0.65901 11.659C1.08097 11.2371 1.65326 11 2.25 11H12.75C13.3467 11 13.919 11.2371 14.341 11.659C14.7629 12.081 15 12.6533 15 13.25V13.75C15 13.75 15 19 7.5 19C0 19 0 13.75 0 13.75V13.25Z",
    fill: "url(#paint3_linear_2862_471)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.5C21.5 5.95963 21.4095 6.41475 21.2336 6.83939C21.0577 7.26403 20.7999 7.64987 20.4749 7.97487C20.1499 8.29988 19.764 8.55769 19.3394 8.73358C18.9148 8.90947 18.4596 9 18 9C17.5404 9 17.0852 8.90947 16.6606 8.73358C16.236 8.55769 15.8501 8.29988 15.5251 7.97487C15.2001 7.64987 14.9423 7.26403 14.7664 6.83939C14.5905 6.41475 14.5 5.95963 14.5 5.5C14.5 4.57174 14.8687 3.6815 15.5251 3.02513C16.1815 2.36875 17.0717 2 18 2C18.9283 2 19.8185 2.36875 20.4749 3.02513C21.1313 3.6815 21.5 4.57174 21.5 5.5Z",
    fill: "url(#paint4_linear_2862_471)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9C8.09095 9 8.67611 8.8836 9.22208 8.65746C9.76804 8.43131 10.2641 8.09984 10.682 7.68198C11.0998 7.26412 11.4313 6.76804 11.6575 6.22208C11.8836 5.67611 12 5.09095 12 4.5C12 3.90905 11.8836 3.32389 11.6575 2.77792C11.4313 2.23196 11.0998 1.73588 10.682 1.31802C10.2641 0.900156 9.76804 0.568688 9.22208 0.342542C8.67611 0.116396 8.09095 -1.24533e-08 7.5 0C6.30653 2.51506e-08 5.16193 0.474106 4.31802 1.31802C3.47411 2.16193 3 3.30653 3 4.5C3 5.69347 3.47411 6.83807 4.31802 7.68198C5.16193 8.52589 6.30653 9 7.5 9Z",
    fill: "url(#paint5_linear_2862_471)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2862_471",
    x1: 14.849,
    y1: 11.798,
    x2: 16.787,
    y2: 17.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139488"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2862_471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.472 14) rotate(-6.31981) scale(7.94891 7.0855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#3B148A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B148A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2862_471",
    x1: 3.567,
    y1: 12.064,
    x2: 6.291,
    y2: 20.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA397"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2862_471",
    x1: 7.5,
    y1: 10.048,
    x2: 11.325,
    y2: 23.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134A45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2862_471",
    x1: 16.165,
    y1: 2.931,
    x2: 19.732,
    y2: 8.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12776E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2862_471",
    x1: 5.14,
    y1: 1.196,
    x2: 9.727,
    y2: 8.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12867C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/guests.a60fdfb8b58e5423064461d70459a975.svg";
export { ForwardRef as ReactComponent };